import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 13c-1.103 0-2-.897-2-2V4h5.185A2.995 2.995 0 0 0 17 6c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 0 0-2.816 2H5.816A2.997 2.997 0 0 0 3 0C1.346 0 0 1.346 0 3s1.346 3 3 3a2.997 2.997 0 0 0 2.816-2H7v7c0 2.206 1.794 4 4 4a1 1 0 0 0 0-2zm5.977-2c.026.001.649.04 1.316.707a1 1 0 0 0 1.414-1.414A4.49 4.49 0 0 0 18 9.2V9a1 1 0 0 0-2 0v.185A2.995 2.995 0 0 0 14 12c0 2.28 1.725 2.712 2.756 2.97h.002C17.873 15.249 18 15.354 18 16c0 .552-.448 1-.976 1-.026-.001-.65-.04-1.317-.707a1 1 0 0 0-1.414 1.414c.479.49 1.062.863 1.707 1.093v.2a1 1 0 0 0 2 0v-.185A2.992 2.992 0 0 0 20 16c0-2.28-1.725-2.712-2.756-2.97h-.001C16.128 12.751 16 12.646 16 12c0-.552.449-1 .977-1z"
});

var SvgTransactionFeeDollarMajor = function SvgTransactionFeeDollarMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgTransactionFeeDollarMajor as S };
